import { render, staticRenderFns } from "./FieldWorkplaceMaterialList.vue?vue&type=template&id=1ca5fa8a&scoped=true"
import script from "./FieldWorkplaceMaterialList.vue?vue&type=script&lang=js"
export * from "./FieldWorkplaceMaterialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca5fa8a",
  null
  
)

export default component.exports